import { createStore, createHook, createActionsHook } from 'react-sweet-state';

import * as actions from './actions';
import { initialState } from './constants';
import type { AssistantMessage, BotMessage, ChatMessage, State } from './types';

const store = createStore({
    initialState,
    actions,
    name: 'CONVERSE',
});

export const useIsLoading = createHook(store, {
    selector: (state) => state.isLoading,
});

export const useConversation = createHook(store, {
    selector: (state) => state.conversation,
});

export const useIsTesting = createHook(store, {
    selector: (state) => state.isTesting,
});
export const useFeedbackCollectorConfig = createHook(store, {
    selector: (state) => state.feedbackCollectorConfig,
});

export const getMessageFeedback = createHook(store, {
    selector: (state, messageId: string | undefined) => {
        const findBotOrAssistantMessage = (chatMessage: ChatMessage): chatMessage is BotMessage | AssistantMessage => {
            return (
                chatMessage &&
                (chatMessage.userType === 'bot' || chatMessage.userType === 'assistant') &&
                chatMessage.messageMetadata.messageId === messageId
            );
        };

        const message = state.conversation?.history.find(findBotOrAssistantMessage);

        return message ? message?.messageMetadata.messageFeedback : undefined;
    },
});

export const useIsFeedbackRecorded = createHook(store, {
    selector: (state: State) => {
        if (state.conversation?.history == null) {
            return true;
        }
        const lastMessage = state.conversation?.history.slice(-1)[0];
        return (
            (lastMessage && ['error', 'authentication', 'feedback'].indexOf(lastMessage.userType) !== -1) ||
            (lastMessage &&
                (lastMessage.userType === 'bot' || lastMessage.userType === 'assistant') &&
                lastMessage.messageMetadata.messageFeedback)
        );
    },
});

export const useActions = createActionsHook(store);
